"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconBase = _interopRequireDefault(require("./IconBase"));
var AlertIcon = function AlertIcon(props) {
  return _react["default"].createElement(_IconBase["default"], props, _react["default"].createElement("path", {
    d: "M62.8,56.6c-0.6,1.1-1.5,1.9-2.6,2.5c-1.1,0.6-2.3,0.9-3.5,0.9H7.3c-1.3,0-2.4-0.3-3.5-0.9 c-1.1-0.6-2-1.5-2.6-2.6c-1.3-2.3-1.4-4.7-0.1-7L25.8,4.4c0.6-1.1,1.5-2,2.6-2.7c2.2-1.3,5-1.3,7.2,0c1.1,0.7,2,1.6,2.6,2.7 c0,0,0,0,0,0l24.7,45.2C64.1,51.9,64.1,54.3,62.8,56.6z M35,37.5V19.9c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v17.6c0,1.7,1.3,3,3,3 C33.6,40.5,35,39.2,35,37.5z M35,48.4v-1.5c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v1.5c0,1.7,1.3,3,3,3C33.7,51.4,35,50.1,35,48.4z"
  }));
};
var _default = AlertIcon;
exports["default"] = _default;
AlertIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AlertIcon"
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["icons/AlertIcon.js"] = {
    name: "AlertIcon",
    docgenInfo: AlertIcon.__docgenInfo,
    path: "icons/AlertIcon.js"
  };
}